// extracted by mini-css-extract-plugin
export default {"background":"ResetPassword_background__q9ZIj","form":"ResetPassword_form__3KtU3","close":"ResetPassword_close__EYUEl","container":"ResetPassword_container__pE9uX"};